export default "__VITE_ASSET__BRQNaIT3__"